export * from './hook';
export * from './types';
export * from './utils';

/**
 * @deprecated Hotjar integration has been removed
 */
export function useHotjarRecording() {
  // HOTJAR INTEGRATION REMOVED --- IGNORE ---
}
